(() => {
  document.querySelectorAll('[data-lance-drafting-combination]').forEach(root => {
    if (root.dataset.ready || !window.LanceSelection) return;
    root.dataset.ready = 'true';
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-draft-variants]').textContent); } catch (_) { return; }
    const slots = [...root.querySelectorAll('[data-draft-slot]')];
    const form = root.querySelector('[data-draft-form]'), button = root.querySelector('[data-draft-add]'), status = root.querySelector('[data-draft-status]');
    let busy = false;
    const selected = slot => variants.find(v => String(v.id) === slot.querySelector('[data-draft-select]').value);
    const included = slot => !slot.hasAttribute('data-optional') || slot.querySelector('[data-draft-include]').checked;
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents / 100);
    const signal = (name, parameters) => document.dispatchEvent(new CustomEvent('lance:shopping-signal', {detail:{name,parameters}}));
    const update = () => {
      let total = 0, count = 0, valid = true;
      slots.forEach(slot => {
        const v = selected(slot), use = included(slot);
        slot.querySelector('[data-draft-select]').disabled = busy || !use;
        if (use) { count++; if (!v || !v.available) valid = false; total += v?.price || 0; }
        const set = (selector, value) => { slot.querySelector(selector).textContent = value; };
        set('[data-draft-product]', v?.product || 'Choose an exact configuration');
        set('[data-draft-size]', v?.title || 'Not selected');
        set('[data-draft-sku]', v?.sku || 'Not selected');
        set('[data-draft-price]', v ? v.money + ' each' : 'Price unavailable');
        set('[data-draft-availability]', v?.available ? 'Available to order' : 'Currently unavailable — choose an available size');
        set('[data-draft-shipping]', v?.shipping || 'Confirm shipping for this configuration.');
        const link = slot.querySelector('[data-draft-link]');
        if(v) link.href = v.url;
        const checkbox = slot.querySelector('[data-draft-include]'); if(checkbox) checkbox.disabled = busy;
      });
      root.querySelector('[data-draft-total]').textContent = money(total);
      root.querySelector('[data-draft-count]').textContent = count + ' individual tools';
      button.disabled = busy || !valid;
      button.textContent = busy ? 'Adding selected tools…' : valid ? 'Add these ' + (count === 2 ? 'two' : 'three') + ' tools' : 'Choose available configurations';
      root.querySelector('[data-draft-share]').href = window.LanceSelection.url(slots.filter(included).map(selected).filter(Boolean).map(v=>({id:v.id,handle:v.handle,quantity:1})),'drawing_board');
    };
    root.querySelectorAll('[data-draft-enhancement]').forEach(el => { el.hidden = false; });
    root.querySelectorAll('[data-draft-select],[data-draft-include]').forEach(control => control.addEventListener('change', () => {
      status.textContent = '';
      update();
      const slot = control.closest('[data-draft-slot]'), v = selected(slot);
      signal('lance_drafting_select', {job:'drawing_board',action:control.matches('[data-draft-include]') ? 'toggle_optional' : 'choose_variant',step:slot.dataset.draftSlot,choice:included(slot)?'included':'excluded',variant_id:v?.id,product_handle:v?.handle});
    }));
    document.addEventListener('lance:variant-changed', event => {
      if(busy) return;
      const id = event.detail?.variant?.id;
      const slot = slots.find(s => [...s.querySelector('[data-draft-select]').options].some(o => Number(o.value) === id));
      if(!slot) return;
      slot.querySelector('[data-draft-select]').value = String(id);
      update();
      status.textContent = 'Combination selection updated to the size chosen above. Confirm the included tools before adding.';
    });
    form.addEventListener('submit', event => event.preventDefault());
    button.addEventListener('click', async event => {
      event.preventDefault();
      if(busy || button.disabled) return;
      const choices = slots.filter(included).map(selected);
      if(choices.length < 2 || choices.some(v=>!v?.available)) { update(); return; }
      busy = true; update(); status.textContent = 'Adding only the displayed included selections…';
      try {
        await window.LanceSelection.add(choices.map(v=>({id:v.id,quantity:1})));
        signal('lance_drafting_add', {job:'drawing_board',action:'added_displayed_selection',choice:choices.length+' tools'});
        window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (_) {
        status.textContent = 'The complete selection could not be confirmed. Review your cart before trying again—some tools may already be there. Check unavailable sizes on their product pages.';
        busy = false; update();
      }
    });
    update();
  });
})();
